import { render, staticRenderFns } from "./Scan.vue?vue&type=template&id=60508c4d&scoped=true&"
import script from "./Scan.vue?vue&type=script&lang=ts&"
export * from "./Scan.vue?vue&type=script&lang=ts&"
import style0 from "./Scan.vue?vue&type=style&index=0&id=60508c4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60508c4d",
  null
  
)

export default component.exports